var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFondoFormacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 1013,
    viewBox: "0 0 1280 1013",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_3099)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1013,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1136.35 284.137C952.587 336.781 889.019 564.158 1002.79 713.373L1059.17 671.654C934.265 508.619 1099.71 278.689 1292.79 365.196C1414.02 419.474 1443.56 569.922 1362.01 671.912C1375.92 679.309 1399.26 703.022 1411.27 708.413C1414.91 710.047 1417.61 711.538 1421.19 708.556C1579.52 504.776 1387.67 212.168 1136.35 284.137Z",
    fill: "#285171",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.99 718.677C1281.67 667.123 1385.47 616.314 1347.19 500.102C1300.36 357.97 1081.59 379.274 1069.57 532.818C1066.94 566.423 1082.45 619.526 1110.06 639.826L1162.1 605.476C1071.47 519.973 1213.89 406.858 1277.83 503.084C1311.69 554.065 1273.55 595.268 1234.27 624.486C1174.86 668.643 1105.3 701.875 1045.92 746.662C1043.6 750.074 1095.64 782.991 1103.44 782.446C1130.13 764.898 1156.34 746.605 1183.32 729.487C1186.73 727.308 1196.62 722.147 1201.96 718.706",
    fill: "#285171",
    fillOpacity: 0.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.13 802.145C1177.67 805.155 1215.92 811.291 1265.87 802.202C1303.72 795.321 1335.23 780.898 1376.55 751.881L1323.24 704.054L1170.16 802.145H1170.13Z",
    fill: "#285171",
    fillOpacity: 0.29
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_3099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1013,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFondoFormacion);
export default __webpack_public_path__ + "static/media/fondo_formacion.d053c98ec782a8d890be44df60688d75.svg";
export { ForwardRef as ReactComponent };